import { createReducerContext } from '../../../../utils/create-reducer-context';
import { ManagementUnitSearchState, ManagementUnitSearchReducer, ACTION_TYPES } from './management-unit-search-reducer';

const initialState: ManagementUnitSearchState = {
    parameters: { page: 0, pageSize: 25 },
    searchTrigger: 0,
    drawer: { open: false },
};

const { Provider: ManagementUnitSearchProvider, useStateContext: useManagementUnitSearchState, useDispatchContext: useManagementUnitSearchDispatch } = createReducerContext('ManagementUnitSearch', ManagementUnitSearchReducer, initialState);

export { ManagementUnitSearchProvider, useManagementUnitSearchState, useManagementUnitSearchDispatch, ACTION_TYPES };
